<edl-auth-authenticated-header>
    <img src="../../../../assets/logo.png" alt="Comply by Edulink" title="Comply by Edulink" class="standard-image"/>
    <img src="../../../../assets/logo.png" width="103" height="32.5" alt="Comply by Edulink" title="Comply by Edulink" class="mobile-image"/>
    <ul role="navigation" aria-label="Main navigation">
        <li>
            <button type="button"
                    class="btn btn-link volunteers-button"
                    *ngIf="isVolunteerEnabled; else supportLink"
                    (click)="showSupportInfoModal()">
                Support
            </button>
            <ng-template #supportLink>
                <a href="https://edulink.freshdesk.com/support/home"
                target="_blank"
                rel="noopener">Support</a>
            </ng-template>
        </li>
        <li><a uiSref="authenticated.messages.my-messages" [uiParams]="messagesParams" >Messages</a></li>
        <li><a uiSref="authenticated.site-map">Site Map</a></li>
        <li><button type="button" class="logout-button btn btn-link" (click)="logout()">Logout</button></li>
    </ul>
    <div class="user-popup">
        <strong>Email:</strong>
        <p>{{ user?.Email }}</p>

        <strong>Permissions:</strong>
        <ul>
            <li *ngFor="let applicationRole of user?.UserPortal?.ApplicationRoles | userPermission: user?.AccessRoleID" [innerHtml]="applicationRole.AccessName"></li>
        </ul>

        <a uiSref="authenticated.users.user.edit" [uiParams]="{ userId: user?.UserID }" class="btn btn-secondary" style="margin-top: 10px; width: 100%;">Update Profile</a>
    </div>
</edl-auth-authenticated-header>
